import React from "react";

interface PayButtonProps {
  onClick: () => void;
  disabled?: boolean;
  amount?: number;
}

export default function PayButton({ onClick, disabled = false, amount }: PayButtonProps) {
  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 flex justify-center w-full max-w-160 z-999 bg-white/80 backdrop-blur-md pt-4 pb-safe px-5 border-t border-gray-200" style={{ paddingBottom: "max(20px, env(safe-area-inset-bottom, 20px))" }}>
      <button
        onClick={onClick}
        disabled={disabled}
        className="w-full h-14 rounded-[14px] font-gmarket border-none transition-[background-color,scale] duration-150 ease-out cursor-pointer disabled:cursor-not-allowed bg-[#e16036] hover:bg-[#D55328] disabled:bg-gray-200 text-white disabled:text-gray-400 flex items-center justify-center active:not-disabled:scale-[0.98] shadow-[0_8px_24px_-8px_rgba(225,96,54,0.55)] disabled:shadow-none"
      >
        <span className="text-xl font-bold tracking-[0.3px] tabular-nums">
          {amount !== undefined ? `${amount.toLocaleString()}원 결제하기` : "결제하기"}
        </span>
      </button>
    </div>
  );
}
